import { useT } from "../lib/i18n";

export const Marquee = () => {
  const ITEMS = useT().marquee;
  return (
  <section className="bg-[var(--ink)] text-[var(--bone)] py-7 md:py-9 overflow-hidden" data-testid="marquee">
    <div className="marquee-track flex w-max whitespace-nowrap">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
          {ITEMS.map((t, i) => (
            <span key={t} className="flex items-center font-display text-3xl md:text-5xl font-medium tracking-tight px-8">
              {i % 2 ? <span className="font-serif-i font-normal">{t}</span> : t}
              <span className="ml-16 w-3 h-3 rounded-full bg-[var(--red)] inline-block" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
  );
};
